import React from 'react';
import { useSelector } from 'react-redux';

import CollageContainer from 'ugc/components/ugcGallery/collage/CollageContainer';

export default function WrapperCollage({ data }) {
    const { promoIdOfUgcLink: promoId } = useSelector(s => s.promo);
    const buttonClickLink = `/ugc/${promoId}${window.location.search}${window.location.hash}`;
    return (
        <CollageContainer
            config={data.settingGame.galleryGameSetting}
            buttonClickLink={buttonClickLink}
        />
    );
}
